import styled from "styled-components";
import StyledLocalLink from "features/shared/components/link/styles/StyledLocalLink.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";
import QuestionsCard from "./QuestionsCard.styled";

const StyledQuestionsForm = styled.div`
  padding: 24px 0;

  ${QuestionsCard} {
    margin-top: 24px;
  }

  ${StyledLocalLink} {
    margin-bottom: 24px;
  }

  ${TertiaryHeader} {
    margin-bottom: 8px;
  }
`;

export default StyledQuestionsForm;
